import { useEffect, useState, useContext } from "react";
import { NotificationManager } from "react-notifications";
import VirtualizedTable from "../../General/Common/VitualizedTable/VirtualizedTable";
import ExportButtton from "../../General/Buttons/ExportButtton";
import { callApi } from "../../General/GeneralMethod";
import { LoadingContext } from "../../store/loading-context";
import {
  APICALLFAIL,
  APINULLERROR,
  SRNO,
  SRNOKEY,
  SRNOWIDTH,
  INT,
  TEXT,
  ACTION,
  WIDTH,
} from "../../General/ConstStates";

const TempCabBookingsList = () => {
  const [bookingList, setBookingList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { startLoading, stopLoading } = useContext(LoadingContext);

  const columns = [
    {
      label: SRNO,
      dataKey: SRNOKEY,
      width: SRNOWIDTH,
      type: INT,
      isShow: true,
      cellRenderer: ({ rowIndex }) => rowIndex + 1,
    },
    { label: "Booking Type", dataKey: "bookingType", type: TEXT, width: 150,isShow:true },
    { label: "User Phone", dataKey: "userPhone", type: TEXT, width: 150, isShow:true},
    { label: "Pickup Location", dataKey: "pickupLocation", type: TEXT, width: 250,isShow:true },
    { label: "DropOff Location", dataKey: "dropOffLocation", type: TEXT, width: 250,isShow:true },
    { label: "Pickup Time", dataKey: "pickupTime", type: TEXT, width: 180,isShow:true },
    { label: "DropOff Time", dataKey: "dropOffTime", type: TEXT, width: 180,isShow:true },
    { label: "Created At", dataKey: "createdAt", type: TEXT, width: 180 ,isShow:true},
  ];

  // 🔹 Fetch bookings (with optional date filters)
  const fetchBookings = async () => {
    startLoading();
    try {
      let query = "";
      if (fromDate && toDate) {
        query = `?fromDate=${fromDate}&toDate=${toDate}`;
      }
      const response = await callApi(
        "get",
        `${process.env.REACT_APP_API_URL_ADMIN}Data/GetAllBookingLead${query}`,
        {},
        {}
      );
  console.log(response.data)
      if (response && response.data) {
        setBookingList(response.data);
        setFilteredList(response.data);
      } else if (response?.data) {
        setBookingList(response.data);
        setFilteredList(response.data);
      } else {
        NotificationManager.error(response?.data?.message || APINULLERROR);
        setBookingList([]);
      }
    } catch (err) {
      NotificationManager.error(APICALLFAIL);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);
 useEffect(() => {
    console.log(filteredList)
  }, [filteredList]);
  const handleDateFilter = () => {
    fetchBookings();
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    fetchBookings();
  };

  return (
    <div className="wrapper">
      <div className="main">
        <main className="content">
          <div className="container-fluid p-0">
            <h1 className="h3 mb-3">Temp Cab Bookings</h1>

            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div>
                    <label>From Date:</label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div>
                    <label>To Date:</label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="d-flex align-items-end gap-2 mt-2">
                    <button
                      className="btn btn-primary"
                      onClick={handleDateFilter}
                    >
                      Apply
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleClearFilters}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <ExportButtton
                  columns={columns}
                  fileName={"Temp_Cab_Bookings"}
                  data={bookingList}
                />
              </div>

              <div className="card-body">
                <VirtualizedTable
                  tableData={filteredList}
                  columns={columns}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TempCabBookingsList;
